export const STYLE_HIDDEN = 'layout-hidden';
export const STYLE_DISABLED = 'layout-disabled';
export const STYLE_WAITING = 'layout-waiting';
export const STYLE_ACTIVE = 'layout-active';
export const STYLE_INACTIVE = 'layout-inactive';
export const STYLE_PLAYING = 'layout-playing';
export const STYLE_RECORDING = 'layout-recording';
